/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/wrm/no-load-bridge
import { loadBridgeStrict } from '@jira/platform__bridge/src';

const amdModuleName = 'jira-agile/sidebar/create-board-adg3';

const createBoardLegacy = async (): Promise<void> => {
	// eslint-disable-next-line jira/wrm/no-load-bridge
	const module = await loadBridgeStrict({
		name: amdModuleName,
		wrmKeys: ['wrc!com.pyxis.greenhopper.jira:gh-create-board'],
	});

	// @ts-expect-error - TS2571 - Object is of type 'unknown'.
	return module.openCreateBoardModal();
};

export default createBoardLegacy;
